export const RETEST_START_ERROR_KIND = {
  neoAlreadyRunning: 'neoAlreadyRunning',
  noSignalId: 'noSignalId',
  internalNetwork: 'internalNetwork',
  generic: 'generic',
} as const;

export type RetestStartErrorKind =
  (typeof RETEST_START_ERROR_KIND)[keyof typeof RETEST_START_ERROR_KIND];

const NEO_ALREADY_RUNNING_MESSAGE =
  'A Neo execution is already running on this signal';
const NO_SIGNAL_ID_MESSAGE = 'Finding has no signalId — cannot retest';
const INTERNAL_NETWORK_MESSAGE =
  'Internal network findings are retested through the internal attack path';

export const mapRetestStartErrorMessage = (
  message: string,
): RetestStartErrorKind => {
  if (message === NEO_ALREADY_RUNNING_MESSAGE) {
    return RETEST_START_ERROR_KIND.neoAlreadyRunning;
  }

  if (message === NO_SIGNAL_ID_MESSAGE) {
    return RETEST_START_ERROR_KIND.noSignalId;
  }

  if (message === INTERNAL_NETWORK_MESSAGE) {
    return RETEST_START_ERROR_KIND.internalNetwork;
  }

  return RETEST_START_ERROR_KIND.generic;
};

export const RETEST_START_ERROR_I18N_KEY: Record<
  RetestStartErrorKind,
  | 'retest.triggerErrorNeoAlreadyRunning'
  | 'retest.triggerErrorNoSignalId'
  | 'retest.triggerErrorInternalNetwork'
  | 'retest.triggerErrorDescription'
> = {
  neoAlreadyRunning: 'retest.triggerErrorNeoAlreadyRunning',
  noSignalId: 'retest.triggerErrorNoSignalId',
  internalNetwork: 'retest.triggerErrorInternalNetwork',
  generic: 'retest.triggerErrorDescription',
};
